export default __webpack_public_path__ + "static/media/argon-react.24c0d7d7.png";